"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _search = _interopRequireDefault(require("../../assets/icons/search.svg"));

var _filterFilled = _interopRequireDefault(require("../../assets/icons/filter-filled.svg"));

var _filterOutlined = _interopRequireDefault(require("../../assets/icons/filter-outlined.svg"));

var _typography = _interopRequireDefault(require("../typography"));

var _checkbox = _interopRequireDefault(require("../checkbox"));

var _textfield = _interopRequireDefault(require("../textfield"));

var _button = _interopRequireDefault(require("../button"));

var _radio = _interopRequireDefault(require("../radio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-table-container {\n  width: 100%;\n  height: 100%;\n  min-width: 26.5rem; }\n  .bds-table-container .bds-table-sort-icon-resize-container {\n    display: flex; }\n  .bds-table-container .bds-table {\n    width: 100%;\n    height: 100%;\n    display: table;\n    position: relative; }\n  .bds-table-container .bds-table-search {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    box-sizing: border-box;\n    min-height: 3.5rem;\n    border-bottom: none;\n    display: flex;\n    align-items: center;\n    justify-content: end;\n    flex-wrap: wrap;\n    padding-right: 0.5rem;\n    background: #ffffff;\n    max-width: 100%;\n    min-width: 26.5rem; }\n  .bds-table-container .bds-table-search-container {\n    display: flex;\n    padding-left: 0.5rem;\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem; }\n    .bds-table-container .bds-table-search-container .search-container {\n      border-color: #a8a8a8; }\n  .bds-table-container table.bds-table thead th {\n    min-width: 5.5rem; }\n  .bds-table-container .bds-table-header-cell {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    padding-right: 0;\n    font-size: 0.875rem;\n    min-width: 5.5rem;\n    height: 3.5rem;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    background: #ffffff; }\n  .bds-table-container .bds-table-header-cell-no-background {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    padding-right: 0;\n    font-size: 0.875rem;\n    min-width: 5.5rem;\n    height: 3.5rem;\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1; }\n  .bds-table-container .bds-table-header-cell:first-child {\n    border-left: none; }\n  .bds-table-container .bds-table-header-cell:last-child {\n    border-right: none; }\n  .bds-table-container .bds-table-header-text-icon {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    min-width: 0;\n    overflow: hidden;\n    height: 100%; }\n  .bds-table-container .bds-table-resizer {\n    display: flex;\n    background: none;\n    width: 0.03125rem;\n    height: 2rem;\n    min-width: 0;\n    padding: 0 1px;\n    cursor: col-resize; }\n  .bds-table-container .bds-table-resizer-hover {\n    background: #a8a8a8; }\n  .bds-table-container .bds-table-header-text {\n    font-weight: 700;\n    font-family: \"OpenSansRegular\";\n    letter-spacing: 0.03125rem;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -ms-text-overflow: ellipsis;\n    min-width: 0;\n    white-space: nowrap; }\n  .bds-table-container .bds-table-header-text-cursor {\n    cursor: pointer; }\n  .bds-table-container .bds-table-header-icon {\n    display: flex;\n    align-items: center;\n    cursor: pointer; }\n  .bds-table-container .bds-table-cell {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\";\n    line-height: 1.1875rem;\n    letter-spacing: 0.02rem;\n    padding-top: 0.84375rem;\n    padding-bottom: 0.90625rem;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    max-width: 0; }\n  .bds-table-container .bds-table-cell-render {\n    box-sizing: border-box;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: #393939;\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\";\n    line-height: 1.1875rem;\n    letter-spacing: 0.02rem;\n    border-bottom: 0.03125rem solid #c6c6c6;\n    max-width: 0; }\n  .bds-table-container .bds-table-expanded-row {\n    background-color: #EEEEEE;\n    transition: height 0.5s ease-in; }\n  .bds-table-container .bds-table-expanded-row-cell-render {\n    line-height: 3.1875rem; }\n  .bds-table-container .bds-table-expanded-row-no-data-found {\n    display: flex;\n    justify-content: space-around; }\n  .bds-table-container .bds-table-expand-row {\n    display: flex;\n    gap: 2px;\n    align-items: center; }\n  .bds-table-container .bds-table-expand-row-icons {\n    cursor: pointer; }\n  .bds-table-container .bds-table-row > .bds-table-cell-render:last-child {\n    border-right: none; }\n  .bds-table-container .bds-table-cell-custom {\n    box-sizing: border-box;\n    width: 100%;\n    border-left: none;\n    overflow: hidden; }\n  .bds-table-container .bds-table-row td:last-child .bds-table-cell-custom {\n    border-right: none; }\n  .bds-table-container .bds-table-row td.bds-table-cell:last-child {\n    border-right: none; }\n  .bds-table-container .bds-table-row-selectable:hover {\n    cursor: pointer; }\n  .bds-table-container .bds-table-row-highlighted {\n    background-color: #e0e0e0; }\n  .bds-table-container .bds-table-row:hover {\n    background-color: #e0e0e0; }\n  .bds-table-container .bds-table-row:hover .bds-table-cell,\n  .bds-table-container .bds-table-cell-render {\n    border-right-color: #e0e0e0;\n    border-left-color: #e0e0e0; }\n  .bds-table-container .bds-overflow-menu-item {\n    font-size: 0.875rem;\n    font-family: \"OpenSansRegular\"; }\n  .bds-table-container .bds-overflow-menu-item:hover {\n    background-color: #e0e0e0;\n    letter-spacing: 0.02rem; }\n  .bds-table-container table,\n  .bds-table-container tbody,\n  .bds-table-container thead,\n  .bds-table-container tr,\n  .bds-table-container th,\n  .bds-table-container td {\n    margin: 0;\n    padding: 0;\n    border: 0;\n    outline: 0;\n    font-size: 100%;\n    vertical-align: middle;\n    background: transparent;\n    border-collapse: unset;\n    text-indent: initial;\n    border-spacing: 0; }\n  .bds-table-container td.bds-table-cell {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -ms-text-overflow: ellipsis;\n    height: 3rem;\n    white-space: nowrap; }\n  .bds-table-container table.bds-table {\n    table-layout: fixed; }\n  .bds-table-container .table-infinite-scroll-inside-modal {\n    -ms-overflow-style: none;\n    scrollbar-width: none; }\n    .bds-table-container .table-infinite-scroll-inside-modal::-webkit-scrollbar {\n      display: none; }\n  .bds-table-container .bds-add-new-row {\n    margin-top: 20px; }\n    .bds-table-container .bds-add-new-row table,\n    .bds-table-container .bds-add-new-row th,\n    .bds-table-container .bds-add-new-row td {\n      background-color: #F4F4F4;\n      border: none; }\n    .bds-table-container .bds-add-new-row th {\n      height: 1rem; }\n    .bds-table-container .bds-add-new-row table {\n      padding-top: 15px;\n      padding-bottom: 15px; }\n  .bds-table-container .bds-empty-new-row-header th {\n    height: 1px; }\n  .bds-table-container .bds-table-column-filter {\n    display: flex;\n    align-items: center;\n    margin-top: 0px; }\n  .bds-table-container .filter-menus {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    color: #333333;\n    border-radius: 6px;\n    position: absolute;\n    min-width: 200px;\n    right: 0px;\n    top: 50px; }\n    .bds-table-container .filter-menus-menu-divider {\n      border: 0;\n      border-top: 1px solid rgba(0, 0, 0, 0.1); }\n    .bds-table-container .filter-menus-filter-list {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      overflow-y: auto;\n      max-height: 280px; }\n    .bds-table-container .filter-menus-action-btns {\n      margin-right: 8px;\n      margin-bottom: 8px;\n      justify-content: flex-end;\n      display: flex;\n      flex-direction: row;\n      gap: 10px; }\n    .bds-table-container .filter-menus-no-data-found {\n      padding: 8px 12px; }\n    .bds-table-container .filter-menus-filter-menus-list {\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      padding: 8px 12px; }\n    .bds-table-container .filter-menus-clear-all {\n      margin-left: 13px;\n      margin-top: 10px;\n      margin-bottom: 10px; }\n  .bds-table-container .filter-icon {\n    width: 22px;\n    height: 22px;\n    cursor: pointer; }\n";
  var fileName = "compone_table";
  var element = document.querySelector("style[data-sass-component='compone_table']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var Filter = function Filter(_ref) {
  var _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      _ref$onApply = _ref.onApply,
      onApply = _ref$onApply === void 0 ? function () {} : _ref$onApply,
      _ref$singleSelector = _ref.singleSelector,
      singleSelector = _ref$singleSelector === void 0 ? false : _ref$singleSelector;
  var filterRef = (0, _react.useRef)();
  var filterIconRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedFilterValues = _useState2[0],
      setSelectedFilterValues = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedRadioValues = _useState4[0],
      setSelectedRadioValues = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = _slicedToArray(_useState5, 2),
      searchText = _useState6[0],
      setSearchText = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isOpen = _useState8[0],
      setIsOpen = _useState8[1];

  var searchedData = searchText ? options.filter(function (filter) {
    return filter === null || filter === void 0 ? void 0 : filter.value.toString().toLowerCase().includes(searchText.toLowerCase());
  }) : options;

  var showAppliedFilterValues = function showAppliedFilterValues() {
    var appliedFilterValues = _toConsumableArray(values); // The list of already applied filter menus


    var filters = _toConsumableArray(selectedFilterValues); // The list of filter menus which is selected but not yet applied
    // To display the list of already applied filters on opening the filter


    if ((filters === null || filters === void 0 ? void 0 : filters.length) !== 0) {
      var finalFilters = filters === null || filters === void 0 ? void 0 : filters.filter(function (data) {
        return appliedFilterValues === null || appliedFilterValues === void 0 ? void 0 : appliedFilterValues.includes(data);
      });
      setSelectedFilterValues(_toConsumableArray(finalFilters));
    } else {
      // To resume already applied filters after clearing all the values and cancelling the same
      setSelectedFilterValues(_toConsumableArray(appliedFilterValues));
    }
  };

  var toggleOpen = function toggleOpen(e) {
    e.stopPropagation();
    setIsOpen(function (prev) {
      return !prev;
    });
    showAppliedFilterValues();
  };

  var handleSearchTxt = function handleSearchTxt(e) {
    var _e$target;

    setSearchText(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
  };

  var handleClose = function handleClose() {
    setIsOpen(false);
    setSearchText(null);
    showAppliedFilterValues();
  };

  var handleApply = function handleApply(e) {
    e.stopPropagation();

    if (singleSelector) {
      onApply(selectedRadioValues);
    } else {
      var filterValues = _toConsumableArray(selectedFilterValues);

      onApply(filterValues);
    }

    setIsOpen(false);
    setSearchText(null);
  };

  var handleColumnFilterValues = function handleColumnFilterValues(event, filterValue) {
    event.stopPropagation();

    var columnFilters = _toConsumableArray(selectedFilterValues); // To store filter values based on column-name


    var index = columnFilters === null || columnFilters === void 0 ? void 0 : columnFilters.indexOf(filterValue);

    if (index !== -1) {
      columnFilters === null || columnFilters === void 0 ? void 0 : columnFilters.splice(index, 1);
    } else {
      columnFilters === null || columnFilters === void 0 ? void 0 : columnFilters.push(filterValue);
    }

    setSelectedFilterValues(columnFilters);
  };

  var handleColumnRadioFilterValues = function handleColumnRadioFilterValues(event) {
    event.stopPropagation();
    setSelectedRadioValues(event.target.value);
  };

  var handleClearAll = function handleClearAll() {
    setSelectedFilterValues([]);
    setSelectedRadioValues('');
  };

  var handleClickOutsideOfFilter = function handleClickOutsideOfFilter(event) {
    // To close the filter if user clicks anywhere outside the filter menus and filter icon
    if (filterRef.current && !filterRef.current.contains(event.target) && filterIconRef && !filterIconRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleClickOutsideOfFilter, true);
    return function () {
      document.removeEventListener('click', handleClickOutsideOfFilter, true);
    };
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    ref: filterIconRef,
    className: "filter-icon"
  }, /*#__PURE__*/_react.default.createElement("img", {
    width: 22,
    src: values.length > 0 ? _filterFilled.default : _filterOutlined.default,
    onClick: toggleOpen,
    alt: "filterIcon"
  })), isOpen && /*#__PURE__*/_react.default.createElement("div", {
    ref: filterRef,
    className: "filter-menus"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      margin: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_textfield.default, {
    placeholder: 'Search',
    icon: /*#__PURE__*/_react.default.createElement("img", {
      width: 22,
      src: _search.default
    }),
    iconPosition: "left",
    width: "100%",
    onChange: handleSearchTxt,
    value: searchText || ''
  })), /*#__PURE__*/_react.default.createElement("hr", {
    className: "filter-menus-menu-divider"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-menus-filter-list"
  }, searchedData && (searchedData === null || searchedData === void 0 ? void 0 : searchedData.length) !== 0 && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: (selectedFilterValues === null || selectedFilterValues === void 0 ? void 0 : selectedFilterValues.length) > 0 ? '#007bff' : '#BEBEBE',
      cursor: (selectedFilterValues === null || selectedFilterValues === void 0 ? void 0 : selectedFilterValues.length) > 0 ? 'pointer' : 'auto'
    },
    className: "filter-menus-clear-all",
    onClick: function onClick() {
      return handleClearAll();
    }
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "Clear All")), (searchedData === null || searchedData === void 0 ? void 0 : searchedData.length) === 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-menus-no-data-found"
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "No match is found")), !singleSelector ? searchedData === null || searchedData === void 0 ? void 0 : searchedData.map(function (filter) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: filter === null || filter === void 0 ? void 0 : filter.value,
      className: "filter-menus-filter-menus-list"
    }, /*#__PURE__*/_react.default.createElement(_checkbox.default, {
      checked: selectedFilterValues === null || selectedFilterValues === void 0 ? void 0 : selectedFilterValues.includes(filter === null || filter === void 0 ? void 0 : filter.value),
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onChange: function onChange(event) {
        event.stopPropagation();
        handleColumnFilterValues(event, filter === null || filter === void 0 ? void 0 : filter.value);
      },
      name: filter === null || filter === void 0 ? void 0 : filter.label,
      label: filter === null || filter === void 0 ? void 0 : filter.label
    }));
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-menus-filter-menus-list"
  }, /*#__PURE__*/_react.default.createElement(_radio.default, {
    direction: "vertical",
    options: searchedData.map(function (filter) {
      return {
        value: filter.value,
        label: filter.label
      };
    }),
    defaultValue: selectedRadioValues,
    onChange: function onChange(event) {
      event.stopPropagation();
      handleColumnRadioFilterValues(event);
    }
  }))), /*#__PURE__*/_react.default.createElement("hr", {
    className: "filter-menus-menu-divider"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "filter-menus-action-btns"
  }, /*#__PURE__*/_react.default.createElement(_button.default, {
    onClick: function onClick() {
      return handleClose();
    },
    variant: "secondary",
    className: "btn btn-light buttons"
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_button.default, {
    variant: "primary",
    onClick: function onClick(e) {
      return handleApply(e);
    },
    className: "filter-menus-apply-buttons"
  }, "Apply"))));
};

Filter.propTypes = {
  options: _propTypes.default.array.isRequired,
  onApply: _propTypes.default.func.isRequired,
  values: _propTypes.default.array.isRequired
};
var _default = Filter;
exports.default = _default;